import React, { useEffect } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { OptionsType } from '../Types';
import { useFormContext, get } from "react-hook-form";
import Tooltip from './Tooltip';

type SelectFieldProps = {
    name: string;
    options: OptionsType[];
    label?: string;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    removeValue?: string;
    tooltipBody?: () => JSX.Element;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

function SelectField({ className, label, name, options, disabled, required, removeValue, tooltipBody, onChange }: SelectFieldProps) {
    const { register, formState: { errors } } = useFormContext();
    const error = get(errors, name);

    const validations = {
        required: required
    };

    return (
        <FormGroup>
            {label && <Label htmlFor={name}>{label}</Label>}
            {tooltipBody &&
                <Tooltip tooltipBody={tooltipBody()} />
            }

            <select {...register(name, validations)}
                id={name}
                name={name}
                className={className ? `form-control  ${className}` : 'form-control'}
                disabled={disabled}
                onChange={(e: any) => onChange && onChange(e)}
            >
                <option value="">Please Select</option>
                {options.map((option: OptionsType) => {
                    if (option.desc !== removeValue) {
                        return (
                            <option key={option.value} value={option.value}>{option.desc}</option>

                        );
                    }
                })}
            </select>
            <div className="form-error-wrapper">
                {error?.type === 'required' && 'This is a required field'}
            </div>
        </FormGroup>
    );
}
export default SelectField;
